var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgContactPhoneImg = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 116,
  height: 116,
  viewBox: "0 0 116 116"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 58,
  cy: 58,
  r: 58,
  fill: "#f0f0f0",
  "data-name": "Ellipse 8"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "#7654fd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.8
}, /*#__PURE__*/React.createElement("path", {
  d: "M60.84 36.879a16.646 16.646 0 0 1 4.161 30.517v7.77",
  "data-name": "Path 570"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.743 52.97a6.936 6.936 0 1 0 6.932-6.936 6.936 6.936 0 0 0-6.936 6.936",
  "data-name": "Path 571"
}), /*#__PURE__*/React.createElement("path", {
  d: "M52.516 47.421V34.937a1.387 1.387 0 0 1 1.388-1.387h5.549a1.406 1.406 0 0 1 1.386 1.387v12.484",
  "data-name": "Path 572"
}), /*#__PURE__*/React.createElement("path", {
  d: "M38.294 60.885a2.774 2.774 0 0 1-1.628-4.235l3.292-5.049v-1.388c0-6.547 5.29-12.04 12.484-13.5",
  "data-name": "Path 573"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.355 75.164v-2.756",
  "data-name": "Path 574"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.605 52.97a13.87 13.87 0 0 1-13.872 13.871h-2.774",
  "data-name": "Path 575"
}))));
export default SvgContactPhoneImg;